import React from "react"
import MyFormControlHelpers from "src/core/components/MyForm/MyFormControlHelpers"
const MFCOnlyLabel = React.lazy(() => import("./Types/only_label"))
const MFCArrayForm = React.lazy(() => import("./Types/array_form"))
const MFCNestedGroup = React.lazy(() => import("./Types/nested_group"))
const MFCLabelCheckBox = React.lazy(() => import("./Types/label_checkbox"))

const List = {
  only_label: MFCOnlyLabel,
  array_form: MFCArrayForm,
  nested_group: MFCNestedGroup,
  label_checkbox: MFCLabelCheckBox,
}
const MyControlForm = {
  init() {
    MyFormControlHelpers.addTypesFromListLazy(List)
  },
}

export default MyControlForm
